import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { AppTypes } from "shell/app/app";
import imagesLoaded from "imagesloaded";
import "./page.scss";

interface pageProps extends AppTypes {}

const Page: React.FC<pageProps> = (props) => {
  const [init, setInit] = useState<boolean>(false);
  const pageRef = useRef<HTMLDivElement>(null);
  const onLoaded = props.onLoaded;

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  useEffect(() => {
    !!pageRef.current &&
      imagesLoaded(pageRef.current, () => {
        setInit(true);
        onLoaded();
      });
  }, [onLoaded]);

  return (
    <div className={classNames("page", { "is-init": init })} ref={pageRef}>
      {props.children}
    </div>
  );
};

export default Page;
